import { GetServerSidePropsContext } from "next/types";
import REST from "@/utils/REST";
import { EncryptTypeEnum, IChapterListQueryTypes } from "./interfaces";

export async function getChapterList(
  query: IChapterListQueryTypes,
  context?: GetServerSidePropsContext
) {
  return await REST.read({
    url: "/go/pcm/chapter/get-chapter-list",
    data: query,
    ctx: context,
  });
}
